"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const T_T = require("cryface");
var HimuraInject;
(function (HimuraInject) {
    class Injector {
        /**
         *
         * @param debugMode
         */
        constructor(debugMode = true) {
            // key Pascal Convention
            this._resources = [];
            if (T_T.simpleDetect(Injector.getInstance())) {
                throw new Error(`Injector Exsists, Invalid Construction.`);
            }
            this.debugMode = debugMode;
            Injector._instance = this;
        }
        static getInstance() {
            return Injector._instance;
        }
        get Resources() {
            return this._resources;
        }
        addResource(key, value) {
            this._resources.push({
                key: key,
                value: value
            });
        }
        removeResourceByKey(key) {
            const res = this.getResourceByKey(key);
            if (T_T.simpleDetect(res)) {
                const index = this._resources.indexOf(res);
                this._resources.splice(index, 1);
            }
            else {
                throw new Error(`Resouce Remove Failed, Not Found Resource<${key}>---------------------------------`);
            }
        }
        getResourceByKey(key) {
            const resource = this._resources.find((res) => { return res.key === key; });
            if (T_T.simpleDetect(resource)) {
                return resource;
            }
            else {
                throw new Error(`Not Found Resource<${key}>---------------------------------------------------------------------------`);
            }
        }
        setResourceByKey(key, value) {
            const resource = this._resources.find((res) => { return res.key === key; });
            if (T_T.simpleDetect(resource)) {
                try {
                    this.removeResourceByKey(key);
                }
                catch (_a) { }
                this.addResource(key, value);
            }
            else {
                this.addResource(key, value);
            }
        }
    }
    HimuraInject.Injector = Injector;
    // Injected Decorator
    function Injected(target, key) {
        const getter = () => {
            if (T_T.simpleDetect(HimuraInject.Injector.getInstance().getResourceByKey(key))) {
                return HimuraInject.Injector.getInstance().getResourceByKey(key).value;
            }
            else {
                return undefined;
            }
        };
        const setter = (object) => {
            if (T_T.simpleDetect(object)) {
                HimuraInject.Injector.getInstance().setResourceByKey(key, object);
            }
        };
        if (delete target[key]) {
            Object.defineProperty(target, key, {
                get: getter,
                set: setter,
            });
        }
    }
    HimuraInject.Injected = Injected;
    // Injected Service
    function Service(constructor) {
        return class extends constructor {
            constructor(...args) {
                super(...args);
                try {
                    const serviceInjected = HimuraInject.Injector.getInstance().getResourceByKey(constructor.name);
                    return serviceInjected.value;
                }
                catch (e) {
                    if (HimuraInject.Injector.getInstance().debugMode) {
                        console.log(`Himura------------------------Not Found Service<${constructor.name}> In The Container, Try To Create.`);
                    }
                    HimuraInject.Injector.getInstance().addResource(constructor.name, this);
                }
            }
        };
    }
    HimuraInject.Service = Service;
    // Injected Named Service
    function NamedService(name) {
        return (constructor) => {
            return class extends constructor {
                constructor(...args) {
                    super(...args);
                    try {
                        const serviceInjected = HimuraInject.Injector.getInstance().getResourceByKey(name);
                        return serviceInjected.value;
                    }
                    catch (e) {
                        if (HimuraInject.Injector.getInstance().debugMode) {
                            console.log(`Himura------------------------Not Found Named Service<${name}> In The Container, Try To Create.`);
                        }
                        HimuraInject.Injector.getInstance().addResource(name, this);
                    }
                }
            };
        };
    }
    HimuraInject.NamedService = NamedService;
    function Init(debugMode = true) {
        const himura = new HimuraInject.Injector(debugMode);
        if (himura.debugMode) {
            console.log('Himura Injector Initiated-----------------------------------------------------');
        }
    }
    HimuraInject.Init = Init;
    // Injected Service
    // export function Service(constructor: Function) {
    //     const serviceName: string = constructor.name;
    //     const newConstructor: Function = function b() { };
    //     constructor = newConstructor;
    //     console.log(constructor);
    //     return newConstructor;
    // }
})(HimuraInject = exports.HimuraInject || (exports.HimuraInject = {}));
//# sourceMappingURL=injector.kit.js.map